<template>
  <v-menu
    ref="dateMenu"
    v-model="dateMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="date"
        :label="label"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        :rules="rules"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      v-model="date"
      :active-picker.sync="activePicker"
      :min="min"
      :max="max"
      @change="saveVisitDate"
    ></v-date-picker>
  </v-menu>

</template>

<script>
  import parseDate from '@/mixins/parseDate';

  export default {
    props: ['value', 'label', 'min', 'max', 'year', 'rules'],
    data: () => ({
      activePicker: null,
      date: null,
      dateMenu: false,
    }),
    watch: {
      value: {
        immediate: true,
        handler(to) {
          if (to) {
            if ((typeof to === 'string') && ( to.length==10 )) {
              this.date = to;
            } else {
              const t = this.parseDateTime(to);
              this.date = t.toFormat('yyyy-MM-dd');
            }
          } else {
            this.date = null;
          }
        },
      },
      dateMenu(val) {
        val && this.year && setTimeout(() => (this.activePicker = 'YEAR'));
      },
    },
    methods: {
      saveVisitDate(date) {
        this.$refs.dateMenu.save(date)
        this.$emit('input', date);
      },
    },
    mixins: [parseDate],
  };
</script>
